import React from 'react';
import ReactDOM from 'react-dom/client';
// Alle Stylesheets in fester Reihenfolge, auch die der nachgeladenen
// Seiten (stile.js erklärt, warum).
import './stile.js';
import App from './App';
/* Der Kreide-Look kommt NACH App: er bricht Flächen auf, die die
   Komponenten-CSS setzt, und muss deshalb später im Stylesheet stehen.
   Die Regeln gewinnen zwar schon über den .doodle-Vorfahren, aber auf die
   Reihenfolge zu bauen ist stabiler als auf jede Spezifität zu zählen. */
import './theme/chalk.css';
// Touch-Geräte: keine Einblendungen, kein klebendes Hover (bewegung.css).
import './theme/bewegung.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
